module.exports = __webpack_public_path__ + "static/media/chatbot-avatar.9ffc9a04.png";